export default "__VITE_ASSET__C4_Tfr2B__"